import { db } from '@/firebaseApp';
import { Teacher as ITeacher } from '@/models/Teachers';
import { IClass } from '@/models/Classes';
import { IRefModule } from '@/models/Modules';

class Modules {
  async createModule(module: any, teacher: ITeacher) {
    const newModule = {
      ...module,
      teacher: {
        uid: null,
        email: teacher.email,
      },
    };

    if (teacher) {
      const newModuleId = (await db.collection('modules').add(newModule)).id;
      await db
        .collection('teachers')
        .doc(teacher.id)
        .set({ modules: teacher.modules.concat([newModuleId]) }, { merge: true });
    }
  }

  async editModule(module: any) {
    if (module) {
      const id = module.id;
      delete module.id;
      await db
        .collection('modules')
        .doc(id)
        .set(module);
    }
  }

  async deleteModule(moduleId: string, teacher: ITeacher) {
    if (!moduleId || !teacher.id) {
      return;
    }

    // delete doc
    await db
      .collection('modules')
      .doc(moduleId)
      .delete();

    // delete from teacher
    const newModuleList = JSON.parse(JSON.stringify(teacher.modules));
    const index = newModuleList.indexOf(moduleId);
    if (index !== -1) {
      newModuleList.splice(index, 1);
    }

    await db
      .collection('teachers')
      .doc(teacher.id)
      .set({ modules: newModuleList }, { merge: true });

    // delete from classroom
    const classRoomSnapshot = await db
      .collection('classrooms')
      .where('teacher.email', '==', teacher.email)
      .get();

    if (!classRoomSnapshot.empty) {
      classRoomSnapshot.forEach(doc => {
        const classRoom = doc.data() as IClass;
        const newClassModuleList = classRoom.modules as IRefModule[];
        const ref = newClassModuleList.find(ref => ref.id === moduleId) as IRefModule;
        if (!ref) {
          return;
        }
        // @ts-ignore
        const index = newClassModuleList.indexOf(ref);
        newClassModuleList.splice(index, 1);

        db.collection('classrooms')
          .doc(doc.id)
          .set({ modules: newClassModuleList }, { merge: true });
      });
    }
  }

  // Don't use in enumerations.
  // It's to slow for that
  async getModuleById(id: string) {
    const doc = await db
      .collection('modules')
      .doc(id)
      .get();

    return doc.exists ? { ...doc.data(), id: doc.id } : null;
  }

  getModulesObserverByTeacherEmail(teacherEmail: string) {
    return db.collection('modules').where('teacher.email', '==', teacherEmail);
  }
}

export default new Modules();
